let runtime_config = {
	// production : {
	// 	path: "/fax"
	// },
	production : {
		path: "http://114.116.47.165:8010",
		//path: "https://info.gaoyuanzb.club:8010/admin"
	},
	test : {
		path: "http://114.116.47.165:8010",
	},
	dev: {
		path: "http://114.116.47.165:8010",
	//	path: "http://localhost:8010"
	},
	local : {
		path: "http://114.116.47.165:8010",
		//path: ""
		
	}
}

export default runtime_config;